import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
 apiKey: "AIzaSyBI-x5H1HJYfjPimDalnw_GjZinbqF6-Nk",
  authDomain: "solvedprinters.firebaseapp.com",
  projectId: "solvedprinters",
  storageBucket: "solvedprinters.firebasestorage.app",
  messagingSenderId: "1079522737087",
  appId: "1:1079522737087:web:025eb98c75b93d059fbf0a",
  measurementId: "G-LNJ95KW22Q"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
